/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlQueryRelation } from './ControlQueryRelation';
import {
    ControlQueryRelationFromJSON,
    ControlQueryRelationFromJSONTyped,
    ControlQueryRelationToJSON,
} from './ControlQueryRelation';

/**
 * 
 * @export
 * @interface ControlQueryRelationsResponseSchema
 */
export interface ControlQueryRelationsResponseSchema {
    /**
     * 
     * @type {Array<ControlQueryRelation>}
     * @memberof ControlQueryRelationsResponseSchema
     */
    relations: Array<ControlQueryRelation>;
}

/**
 * Check if a given object implements the ControlQueryRelationsResponseSchema interface.
 */
export function instanceOfControlQueryRelationsResponseSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "relations" in value;

    return isInstance;
}

export function ControlQueryRelationsResponseSchemaFromJSON(json: any): ControlQueryRelationsResponseSchema {
    return ControlQueryRelationsResponseSchemaFromJSONTyped(json, false);
}

export function ControlQueryRelationsResponseSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlQueryRelationsResponseSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'relations': ((json['relations'] as Array<any>).map(ControlQueryRelationFromJSON)),
    };
}

export function ControlQueryRelationsResponseSchemaToJSON(value?: ControlQueryRelationsResponseSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'relations': ((value.relations as Array<any>).map(ControlQueryRelationToJSON)),
    };
}

